import React from 'react';
import ReactPlayer from 'react-player';

interface VideoPlayerProps {
  src: string;
  width?: string | number;
  height?: string | number;
  autoPlay?: boolean;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  src,
  width,
  height,
  autoPlay = false
}) => {
  return (
    <ReactPlayer
      url={src}
      autoPlay={autoPlay}
      width={width}
      height={height}
      controls
    />
  );
};

export default VideoPlayer;
